<template lang="pug">
.box-solgan
    img(src="../../../../assets/images/home/bg_home.png")
    //- .container
    //-     .box-board
    //-         img(src="../../../assets/images/home/bg_home.png")
    //-         //- .box-top
    //-         //-     .first {{$t("home.first")}}
    //-         //-     .second {{$t("home.second")}}
    //-         //- .box-bottom
    //-         //-     .three {{$t("home.three")}}
    //-         //-     .four {{$t("home.four")}}
    //-     .clearfix
    .clearfix
</template>
<script>
// import gql from 'graphql-tag'
// import graphql from '../../Model/graphqlfront'
import MdNotification from '@/core/components/mdNotification'
import store from '../../../../store'
export default {
  components: {
    MdNotification,
    store
  },
  data() {
    return {}
  },
  methods: {
    numberWithCommas(number) {
      if (number !== undefined && number !== null) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
      return 0
    }
  },
  apollo: {
    // lstLessons: {
    //   query: gql(graphql.GET_LESSONS_HOME),
    //   variables: {
    //     limit: 6,
    //     type_lesson: 1
    //   },
    //   update: data => {
    //     console.log('============= lesson', data.v_front_lesson)
    //     return data.v_front_lesson
    //   }
    // }
  }
}
</script>
<style lang="scss">
.content.front{
    .box-solgan{background: #FBF4D2; margin-bottom:40px; text-align:center;
        img{max-width: 100%; height: auto;}
        .box-board{margin: 0 auto;
            .box-top{ margin-top:120px;
                .first{text-align: center;line-height:54px;font-size: 54px; letter-spacing: 0px;color: #4B2D15; padding-right:140px;}
                .second{text-align: center;line-height:55px;font-size: 55px; letter-spacing: 0px;color: #4B2D15;padding-left:140px;}
            }
            .box-bottom{margin-top:80px; margin-bottom:125px;
                .three{text-align: center;line-height:51px; font-size: 51px; letter-spacing: 0px;color: #CEAA6B;}
                .four{margin-top:11px; text-align: center; line-height:55px;font-size: 55px; letter-spacing: 0px;color: #CEAA6B;}
            }
        }
    }
}
@media (max-width: 1366px){
}
@media (max-width: 1024px){
}
@media (max-width: 991px){
}
@media (max-width: 768px){
    .content.front{
        .box-solgan {margin-bottom: 20px;}
    }
}

@media (max-width: 375px){
    .content.front{
        .box-solgan {margin-bottom: 20px;}
    }
}
@media (max-width: 320px){
    .content.front{
        .box-solgan {margin-bottom: 20px;}
    }
}
</style>




// WEBPACK FOOTER //
// index.vue?f0d2e246